export default {
    completed_fuel_break: {
        name: "Completed Fuel Break",
        url: "nwcg_lines_ops_completed/completed_fuel_break",
    },
    completed_burnout: {
        name: "Completed Burnout",
        url: "nwcg_lines_ops_completed/completed_burnout",
    },
    completed_dozer_line: {
        name: "Completed Dozer Line",
        url: "nwcg_lines_ops_completed/completed_dozer_line",
    },
    "completed_hand_line-1": {
        name: "Completed Hand Line-1",
        url: "nwcg_lines_ops_completed/completed_hand_line-1",
    },
    completed_hand_line: {
        name: "Completed Hand Line",
        url: "nwcg_lines_ops_completed/completed_hand_line",
    },
    completed_plow_line: {
        name: "Completed Plow Line",
        url: "nwcg_lines_ops_completed/completed_plow_line",
    },
    completed_road_as_line: {
        name: "Completed Road As Line",
        url: "nwcg_lines_ops_completed/completed_road_as_line",
    },
}
